const environment = process.env.REACT_APP_MODE ?? "production";
//console.log("environment => ", environment);
//console.log("process.env => ", process.env);

//Define base URL
const getBaseURL = () => {
  switch (environment) {
    case "development":
      return "https://qa-machinefootball-app.azurewebsites.net";
    case "qa":
      return "https://qa-machinefootball-app.azurewebsites.net";
    case "staging":
      return "https://stag-machinefootball-app.azurewebsites.net";
    case "production":
      return "https://machinefootball-app.azurewebsites.net";
    default:
      return "https://machinefootball-app.azurewebsites.net";
  }
};
export const BASE_URL = getBaseURL();

const getB2CApiBaseUrl = () => {
  if (window.location.hostname === "localhost") {
    return "https://dev.machinefootball.com";
  }

  switch (environment) {
    case "development":
    case "dev":
    case "qa":
    case "staging":
      return "https://dev.machinefootball.com";
    case "production":
    default:
      return "https://machinefootball.com";
  }
};

const B2C_API_BASE_URL = getB2CApiBaseUrl();

const isLocalhost = typeof window !== "undefined" && window.location.hostname === "localhost";
const machineFootballMainApiUrl: string = isLocalhost
  ? "/api/main/"
  : "https://machinefootball.com/api/main/";

const BASE_API_GATEWAY_URL: string = "https://machinefootballgateway.azure-api.net/";
// const BASE_API_GATEWAY_URL: string = "http://10.37.54.145/";

const getMainServiceEndPoint = () => {
  switch (environment) {
    case "development":
      return "dev-main-service";
    case "qa":
      return "qa-main-service";
    case "staging":
      return "stag-main-service";
    case "production":
      return "main-service";
    default:
      return "main-service";
  }
};

const getEventServiceEndPoint = () => {
  switch (environment) {
    case "development":
      return "dev-event-service";
    case "qa":
      return "qa-event-service";
    case "staging":
      return "stag-event-service";
    case "production":
      return "event-service";
    default:
      return "event-service";
  }
};


const MAIN_SERVICE_END_POINT = getMainServiceEndPoint();
const EVENT_SERVICE_END_POINT = getEventServiceEndPoint();

const POC_API_URL: string = "https://machinefootballwebapi.azurewebsites.net/";
const mainServiceUrl: string = `${BASE_API_GATEWAY_URL}${MAIN_SERVICE_END_POINT}/`;
const eventServiceUrl: string = `${BASE_API_GATEWAY_URL}${EVENT_SERVICE_END_POINT}/`;

//const mainServiceUrl: string = `${BASE_API_GATEWAY_URL}`

// Define common parts of endpoints
const matchEndPoint: string = "api/Match/";
const teamEndpoint: string = "api/Teams/";
const eventEndpoint: string = "api/Events/";
const playerEndpoint: string = "api/Player/";
const playerNetworkEndpoint: string = "api/PlayerNetwork/";
const squadPlayerEndpoint: string = "api/SquadPlayer/";
const competitionsEndpoint: string = "api/Competition/";
const searchEndpoint: string = "api/Search/";
const teamEventEndpoint: string = "TeamEvent/";
const matchEventEndpoint: string = "MatchEvent/";
const areaEndpoint: string = "api/Area/";
const clubEndpoint: string = "api/Search/";
const chemistryEndpoint = "api/Chemistry/";
const pitchWidgetEndpoint = "api/PitchWidget/";
const userEndpoint = "api/Users/";
const sortListEndpoint = "api/Users/ShortList/";
const valuationEndPoint = "api/Valuation/";
const PlayerPitchWidgetEndPoint = "api/PlayerPitchWidget/";
const authEndpoint = "api/Auth/";
const videoEndPoint = "api/Video/";
const simulationEndPoint = "api/Simulation/"

// Define API endpoints
const apiUrls: Record<string, string> = {
  HomeTeamData: `${mainServiceUrl}${teamEndpoint}GetAllTeamsIds`,
  GetPassingNetworkData: `${mainServiceUrl}${playerNetworkEndpoint}GetPassingNetworkData`,
  GetAllFilteredMatches: `${mainServiceUrl}${matchEndPoint}GetAllFilteredMatches`,
  GetUsersLastMatch: `${mainServiceUrl}${matchEndPoint}GetUsersLastMatch`,
  GetPlayersByTeamMatch: `${mainServiceUrl}${teamEndpoint}GetPlayersByTeamMatch`,
  GetPlayersByTeamMatchForHull: `${mainServiceUrl}${teamEndpoint}GetPlayersByTeamMatchForHull`,
  GetAveragePlayerPositionsByTeamMatch: `${mainServiceUrl}${playerNetworkEndpoint}GetAveragePlayerPositionsByTeamMatch`,
  GetPlayerCardDetail: `${mainServiceUrl}${playerEndpoint}GetPlayerCardDetail`,
  GetTeamCardDetails: `${mainServiceUrl}${teamEndpoint}GetTeamCardDetails`,
  GetTeamsByFilterSearch: `${mainServiceUrl}${teamEndpoint}GetTeamsByFilterSearch`,
  GetTeamFinancialDetail: `${mainServiceUrl}${teamEndpoint}GetTeamFinancialDetail`,
  GetTeamFinancialPlayerTransfers: `${mainServiceUrl}${teamEndpoint}GetTeamFinancialPlayerTransfers`,
  GetTeamFinancialData: `${mainServiceUrl}${teamEndpoint}GetTeamFinancialData`,
  GetTeamFinancialPlayerWagesData: `${mainServiceUrl}${teamEndpoint}GetTeamFinancialPlayerWagesData`,
  GetSquadPlayerCardDetail: `${mainServiceUrl}${squadPlayerEndpoint}GetTeamCurrentSquadPlayersCardData`,
  GetCompetition: `${mainServiceUrl}${competitionsEndpoint}GetCompetition`,
  GetCompetitionSeason: `${mainServiceUrl}${competitionsEndpoint}GetCompetitionSeason`,
  GetAllCompetitionSeasonsByTeamId: `${mainServiceUrl}${competitionsEndpoint}GetAllCompetitionSeasonsByTeamId`,
  GetAllCompetitionSeasonsByPlayerId: `${mainServiceUrl}${competitionsEndpoint}GetAllCompetitionSeasonsByPlayerId`,
  PlayerSearch: `${mainServiceUrl}${searchEndpoint}PlayerSearch`,
  SearchPositionbyZone: `${mainServiceUrl}${searchEndpoint}SearchPositionbyZone`,
  SimilarPlayer: `${mainServiceUrl}${searchEndpoint}SimilarPlayer`,
  GetPlayerAttackPassData: `${eventServiceUrl}${eventEndpoint}GetPlayerAttackPassData`,
  GetMatchEventsDataToPlot: `${eventServiceUrl}${eventEndpoint}GetMatchEventsDataToPlot`,
  GetRiskMapEventsData: `${eventServiceUrl}${eventEndpoint}GetRiskMapEventsData`,
  GetDefensiveActionEventsData: `${eventServiceUrl}${eventEndpoint}GetDefensiveActionEventsData`,
  PlayerExtraDetails: `${mainServiceUrl}${playerEndpoint}PlayerExtraDetails`,
  GetPlayerAttributes: `${mainServiceUrl}${playerEndpoint}GetPlayerAttributes`,
  GetInjuryRecord: `${mainServiceUrl}${playerEndpoint}InjuryRecord`,
  GetPlayerTransfers: `${mainServiceUrl}${playerEndpoint}GetPlayerTransfers`,
  GetAllAreaByRegions: `${mainServiceUrl}${areaEndpoint}GetAllAreaByRegions`,
  GetAllCompetitionsByRegions: `${mainServiceUrl}${areaEndpoint}GetAllCompetitionsByRegions`,
  GetPlayerAssistsForSeasonData: `${eventServiceUrl}${eventEndpoint}GetPlayerAssistsForSeasonData`,
  TeamsRecommendation: `${mainServiceUrl}${searchEndpoint}TeamsRecommendation`,
  GetTeamsByFreeTextSearch: `${mainServiceUrl}${teamEndpoint}GetTeamsByFreeTextSearch`,
  TeamChemistryNetwork: `${mainServiceUrl}${chemistryEndpoint}TeamChemistryNetwork`,
  GetTeamSummaryBar: `${mainServiceUrl}${chemistryEndpoint}GetTeamSummaryBar`,
  GetTeamFormationOfLastMatch: `${mainServiceUrl}${chemistryEndpoint}GetTeamFormationOfLastMatch`,
  TeamFormations: `${mainServiceUrl}${teamEndpoint}TeamFormations`,
  OnSwapPlayerDetail: `${mainServiceUrl}${chemistryEndpoint}OnSwapPlayerDetail`,
  SwapPlayer: `${mainServiceUrl}${chemistryEndpoint}SwapPlayer`,
  OnPlayerClick: `${mainServiceUrl}${chemistryEndpoint}OnPlayerClick`,
  PlayerPassingNetwork: `${eventServiceUrl}${pitchWidgetEndpoint}PlayerPassingNetwork`,
  GetCompetitionSeasonByTeamId: `${mainServiceUrl}${competitionsEndpoint}GetCompetitionSeasonByTeamId`,
  GetTimeLine: `${mainServiceUrl}${matchEndPoint}GetTimeLine`,
  GetSubstitutionOnSwap: `${eventServiceUrl}${pitchWidgetEndpoint}GetSubstitutionOnSwap`,
  SwapPlayerForPN: `${eventServiceUrl}${pitchWidgetEndpoint}SwapPlayerForPN`,
  OnPlayerClickForPN: `${eventServiceUrl}${pitchWidgetEndpoint}OnPlayerClickForPN`,
  GetMatchLevelTimeLineData: `${eventServiceUrl}${eventEndpoint}GetMatchLevelTimeLineData`,
  ThreatMap: `${eventServiceUrl}${pitchWidgetEndpoint}ThreatMap`,
  DefensiveHull: `${eventServiceUrl}${pitchWidgetEndpoint}DefensiveHull`,
  Login: `${mainServiceUrl}${authEndpoint}Login`,
  AddOrUpdate: `${mainServiceUrl}${sortListEndpoint}AddOrUpdate`,
  AddOrUpdateClubShortList : `${mainServiceUrl}${sortListEndpoint}AddOrUpdateClubShortList`,
  ShortList: `${mainServiceUrl}${sortListEndpoint}`,
  GetPlayerCardEventDetails: `${eventServiceUrl}${eventEndpoint}GetPlayerCardEventDetails`,
  GetMatchEventsCardData: `${eventServiceUrl}${eventEndpoint}GetMatchEventsCardData`,
  GetChemistrybetweenPlayers: `${mainServiceUrl}${chemistryEndpoint}GetChemistrybetweenPlayers`,
  TransferValueBenchmark: `${machineFootballMainApiUrl}${valuationEndPoint}TransferValueBenchmark`,
  TransferValueSeasonBenchmark:`${mainServiceUrl}${valuationEndPoint}TransferValueSeasonBenchmark`,
  PlayerSystemFit: `${mainServiceUrl}${chemistryEndpoint}PlayerSystemFit`,
  GetPlayerZonePositions: `${mainServiceUrl}${clubEndpoint}GetPlayerZonePositions`,
  GetTeamPlayerGlobalSearch: `${mainServiceUrl}${searchEndpoint}GetTeamPlayerGlobalSearch`,
  OldSimilarPlayer: `${mainServiceUrl}${searchEndpoint}OldSimilarPlayer`,
  GetTeamsForPresentation: `${mainServiceUrl}${teamEndpoint}GetTeamsForPresentation`,
  PlayerComparison: `${mainServiceUrl}${playerEndpoint}PlayerComparison`,
  TeamsComparison:`${mainServiceUrl}${teamEndpoint}TeamsComparison`,
  PlayerTracker: `${mainServiceUrl}${playerEndpoint}PlayerTracker`,
  GetArchetypeDetails : `${mainServiceUrl}${searchEndpoint}GetArchetypeDetails`,
  GetAttributesOnPitch: `${POC_API_URL}${matchEventEndpoint}GetAttributesOnPitch`,
  TeamsFilterSearch:`${mainServiceUrl}${teamEndpoint}TeamsFilterSearch`,
  GetMinMaxValuesForTeamFilterSearch : `${mainServiceUrl}${teamEndpoint}GetMinMaxValuesForTeamFilterSearch`,
  GetPlayerSpiderGraph: `${mainServiceUrl}${playerEndpoint}GetPlayerSpiderGraph`,
  PlayerBuildUpPlay : `${eventServiceUrl}${PlayerPitchWidgetEndPoint}PlayerBuildUpPlay`,
  PlayerFinalThird: `${eventServiceUrl}${PlayerPitchWidgetEndPoint}PlayerFinalThird`,
  PlayerDefensive: `${eventServiceUrl}${PlayerPitchWidgetEndPoint}PlayerDefensive`,
  GetPlayingstats :`${mainServiceUrl}${playerEndpoint}GetPlayingstats`,
  GetPlayerFormation: `${mainServiceUrl}${playerEndpoint}GetPlayerFormation`,
  PlayerTeamSystemFitView: `${mainServiceUrl}${chemistryEndpoint}PlayerTeamSystemFitView`,
  GetTeamSpiderGraphAsync:`${mainServiceUrl}${teamEndpoint}GetTeamSpiderGraphAsync`,
  GetGameModel:`${eventServiceUrl}${pitchWidgetEndpoint}GetGameModel`,
  GetGameModelSimulation:`${eventServiceUrl}${pitchWidgetEndpoint}GetGameModelSimulation`,
  GetTeamArchetypeDetails:`${mainServiceUrl}${searchEndpoint}GetTeamArchetypeDetails`,
  SynergyByPlayerPair:`${mainServiceUrl}${chemistryEndpoint}SynergyByPlayerPair`,
  PredictiveChemistryByPlayerPair:`${mainServiceUrl}${chemistryEndpoint}PredictiveChemistryByPlayerPair`,
  Register:`${mainServiceUrl}${authEndpoint}Register`,
  SendOtp:`${mainServiceUrl}${authEndpoint}SendOtp`,
  ResetPassword:`${mainServiceUrl}${authEndpoint}ResetPassword`,
  ChangePassword:`${mainServiceUrl}${authEndpoint}ChangePassword`,
  VerifyEmail:`${mainServiceUrl}${authEndpoint}VerifyEmail`,
  GrantAccess:`${mainServiceUrl}${authEndpoint}GrantAccess`,
  GetTeamAttributes:`${mainServiceUrl}${teamEndpoint}GetTeamAttributes`,
  ClubCandidates: `${mainServiceUrl}${searchEndpoint}ClubCandidates`,
  AttributeDriver:`${mainServiceUrl}${valuationEndPoint}AttributeDriver`,
  GetEventByPlayerBestVeap:`${eventServiceUrl}${PlayerPitchWidgetEndPoint}GetEventByPlayerBestVeap`,
  GetVideoClipByFileName: `${mainServiceUrl}${videoEndPoint}GetVideoClipByFileName`,
  GetPlayerNewCardDetails:`${mainServiceUrl}${playerEndpoint}GetPlayerNewCardDetails`,
  ProxyImage: `${mainServiceUrl}${authEndpoint}Proxy-Image`,
  GetPlayerCardImage : `${mainServiceUrl}${authEndpoint}GetPlayerCardImage`,
  GetPlayerSuccessions: `${mainServiceUrl}${playerEndpoint}GetPlayerSuccessions`,
  TeamArchetypeCoachSelectionBySeason : `${mainServiceUrl}${teamEndpoint}TeamArchetypeCoachSelectionBySeason`,
  AnalyzeMultiPlayerSwapV2: `${mainServiceUrl}${simulationEndPoint}AnalyzeMultiPlayerSwapV2`,
  TeamAttributesSimulation: `${mainServiceUrl}${simulationEndPoint}TeamAttributesSimulation`,
  TeamFinancialSimulation: `${mainServiceUrl}${simulationEndPoint}TeamFinancialSimulation`,
  // GetTeamFinancialData:`${mainServiceUrl}${teamEndpoint}GetTeamFinancialData`
};

export default apiUrls;


